var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDislike = function SvgDislike(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0.5H4.99998C4.30831 0.5 3.71665 0.916666 3.46665 1.51667L0.94998 7.39167C0.87498 7.58333 0.833313 7.78333 0.833313 8V9.66667C0.833313 10.5833 1.58331 11.3333 2.49998 11.3333H7.75831L6.96665 15.1417L6.94165 15.4083C6.94165 15.75 7.08331 16.0667 7.30831 16.2917L8.19165 17.1667L13.6833 11.675C13.9833 11.375 14.1666 10.9583 14.1666 10.5V2.16667C14.1666 1.25 13.4166 0.5 12.5 0.5ZM15.8333 0.5V10.5H19.1666V0.5H15.8333Z",
    fill: "#BA1B1B"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDislike, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dislike.f3b300ce.svg";
export { ForwardRef as ReactComponent };